import { render, staticRenderFns } from "./WebRTCConnect.vue?vue&type=template&id=f4fecebe&"
import script from "./WebRTCConnect.vue?vue&type=script&lang=js&"
export * from "./WebRTCConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports